import axios from "@/plugins/axios";
export default {
  toggleSidebarDesktop(state) {
    const sidebarOpened = [true, "responsive"].includes(state.sidebarShow);
    state.sidebarShow = sidebarOpened ? false : "responsive";
  },
  toggleSidebarMobile(state) {
    const sidebarClosed = [false, "responsive"].includes(state.sidebarShow);
    state.sidebarShow = sidebarClosed ? true : "responsive";
  },
  set(state, [variable, value]) {
    state[variable] = value;
  },
  SET_ACCESS_TOKEN(state, payload) {
    state.access_token = payload;
    saveState("access_token", payload);
    setDefaultAuthHeaders(state);
  },
  SET_REFRESH_TOKEN(state, payload) {
    state.refresh_token = payload;
    saveState("refresh_token", payload);
    setDefaultAuthHeaders(state);
  },
  SET_USER(state, payload) {
    state.userId = payload;
    saveState("userId", payload);
    setDefaultAuthHeaders(state);
  },
  SET_TYPE(state, payload) {
    state.type = payload;
    saveState("type", payload);
    setDefaultAuthHeaders(state);
  },
};

function saveState(key, state) {
  window.localStorage.setItem(key, JSON.stringify(state));
}

function setDefaultAuthHeaders(state) {
  if (state.refresh_token) {
    axios.defaults.headers.common.Authorization = state.refresh_token
      ? `${state.refresh_token}`
      : "";
  }
  if (state.access_token) {
    axios.defaults.headers.common.Authorization = state.access_token
      ? `${state.access_token}`
      : "";
  }
  if (state.userId) {
    axios.defaults.headers.common.Authorization = state.userId
      ? `${state.userId}`
      : "";
  }
  if (state.type) {
    axios.defaults.headers.common.Authorization = state.type
      ? `${state.type}`
      : "";
  }
}
